import theme from "@/constants/theme";

export const styles: Record<string, React.CSSProperties> = {
  sentence: {
    fontWeight: 'bold',
    color: 'white',
    // color: isActive ? 'black' : 'white',
    marginBottom: '1rem',
    padding: '0.2rem',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
};
